module.exports = __webpack_public_path__ + "static/img/zhjjsc-BJUdTMI0.f276c6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/zhjjsc-BJUdTMI0.png
// module id = kVMu
// module chunks = 16